module.exports = __webpack_public_path__ + "media/vid_rutin.51c8c656.mp4";